module.exports = __webpack_public_path__ + "static/media/Mumle.e51f3892.m4a";